<template>
    <div class="disease_info">
      <Search :title="name" :conclusion="conclusion">
        <div class="conclusion-desc-box">
          <div v-if="gdb3">
            <p class="conclusion-desc high" v-if="conclusion === 5">高风险</p>
            <p class="conclusion-desc higher" v-if="conclusion === 4">较高风险</p>
            <p class="conclusion-desc general" v-if="conclusion === 3">一般风险</p>
            <p class="conclusion-desc lower" v-if="conclusion === 2">较低风险</p>
            <p class="conclusion-desc low" v-if="conclusion === 1">低风险</p>
          </div>
          <div v-if="gdb2">
            <p class="conclusion-desc high" v-if="conclusion === '高风险'">高风险</p>
            <p class="conclusion-desc higher" v-if="conclusion === '较高风险'">较高风险</p>
            <p class="conclusion-desc general" v-if="conclusion === '一般风险'">一般风险</p>
            <p class="conclusion-desc lower" v-if="conclusion === '较低风险'">较低风险</p>
            <p class="conclusion-desc low" v-if="conclusion === '低风险'">低风险</p>
          </div>

          <ExpandableText :text="desc"></ExpandableText>
        </div>
        <!-- 2020 9 8 注释 -->
        <!-- <div v-if="gdb3">
          <div class="risk" v-if="heritability !== '' && (name === '抑郁症' || name === '哮喘' || name === '自闭症')">
            <p class="risk_title">综合患病风险 =</p>
            <div class="risk_factors">
              <span class="risk_percent">{{ heritability }}</span><span>遗传因素 +</span><span class="risk_percent">{{ (100 - parseFloat(heritability)) | fixed(2) }}%</span><span>环境因素</span>
            </div>
            <div v-if="current_result !== ''">
              <p class="risk_resultTitle">上次现状测试结果：</p>
              <p class="risk_result">{{ current_result }}</p>
              <p class="risk_implication" v-if="name === '抑郁症'" @click="$router.push('/currentSubject?did=1')">重新测试>></p>
              <p class="risk_implication" v-if="name === '哮喘'" @click="$router.push('/currentSubject?did=5')">重新测试>></p>
              <p class="risk_implication" v-if="name === '自闭症'" @click="$router.push('/currentSubject?did=4')">重新测试>></p>
            </div>
          </div>
        </div> -->

        <div class="box" v-if="(type === 'tumour' || this.tumour_info.length !== 0) && sample_type !== 'asa' && sample_type !== 'gsa' && sample_type !== 'childgsa' && sample_type !== 'chrgsa' ">
          <p class="box_title">肿瘤遗传性评估</p>
          <van-tabs v-model="activeTab">
            <van-tab>
              <div slot="title">遗传性筛查</div>
              <GeneList isshow="genetic" :data="heritable_loc"></GeneList>
            </van-tab>
            <van-tab>
              <div slot="title">基因列表</div>
              <div class="tumour_gene_list">
                <span v-for="(item, index) in gene" :key="index">{{ item }}</span>
              </div>
            </van-tab>
            <van-tab>
              <div slot="title">参考文献</div>
              <div v-if="gdb3">
                <Paper :data="documentsTumour"></Paper>
              </div>
              <div class="box-body" v-else-if="gdb2 && type === 'tumour'">
                <p>（1）肿瘤遗传基因选取标准：参考ACMG、NCCN等国际权威指南推荐，结合国内临床遗传学专家建议及最新文献研究，整合成符合中国人群高发肿瘤遗传特点的关键致病基因组合。</p>
                <p>（2）肿瘤遗传位点筛查标准：参考HGMD、ClinVar、OMIM数据库并相互佐证位点判读结果，结合GeneKang数据库人群频率进行初筛，严格按照ACMG标准对可疑位点（致病/疑似致病、临床意义未明/结论冲突）进行人工判读。确保肿瘤高风险遗传变异位点全面覆盖。</p>
              </div>
            </van-tab>
          </van-tabs>
        </div>

        <div v-if="gdb3">
          <div class="box" v-if="type === 'disease'">
            <p class="box_title" v-show="dsystem === '肿瘤'">肿瘤易感性评估</p>
            <van-tabs v-model="activeTab2">
              <van-tab>
                <div slot="title">风险评估</div>
                <DiseaseRisk  :risk="conclusion" :data="conclusion_assess"></DiseaseRisk>
              </van-tab>
              <van-tab>
                <div slot="title">基因列表</div>
                <GeneList isshow="susceptible" :nontumorous="nontumorous" :name="name" :data="gene_list"></GeneList>
              </van-tab>
              <van-tab>
                <div slot="title">参考文献</div>
                <Paper :data="documentsDisease" :fake="fake_gene" :single="single"></Paper>
              </van-tab>
            </van-tabs>
          </div>
        </div>
        <div v-if="gdb2">
          <div class="box" v-if="screening1.length === 0 && conclusion_assess !== null">
            <p class="box_title">肿瘤易感性评估</p>
            <van-tabs v-model="activeTab2">
              <van-tab>
                <div slot="title">风险评估</div>
                <DiseaseRisk :risk="conclusion" :data="conclusion_assess" ></DiseaseRisk>
              </van-tab>
              <van-tab>
                <div slot="title">基因列表</div>
                <GeneList isshow="susceptible" :nontumorous="nontumorous" :data="gene_list"></GeneList>
              </van-tab>
              <van-tab>
                <div slot="title">参考文献</div>
                <Paper :data="documentsDisease" :fake="fake_gene" :single="single"></Paper>
              </van-tab>
            </van-tabs>
          </div>
        </div>

        <div class="disease-content">
          <ExpandableText icon="iconbingli" color="orange" title="致病因素" :text="factors"></ExpandableText>
          <ExpandableText icon="iconhebingxingzhuang" color="pink" title="早期症状" :text="symptom"></ExpandableText>
          <ExpandableText icon="iconjibingxinxihuizong" color="blue" title="体检建议" :text="screening"></ExpandableText>
          <ExpandableText icon="iconleshenghuo" color="gray" title="生活建议" :text="advices"></ExpandableText>
        </div>
        <div v-if="gdb3">
          <Pagination url="diseaseInfo" :id="id"></Pagination>
        </div>
      </Search>
    </div>
</template>

<script>
import Search from '@/components/Search'
import ExpandableText from '@/components/ExpandableText'
import DiseaseRisk from '@/components/DiseaseRisk'
import GeneList from '@/components/GeneList'
import Paper from '@/components/Paper'
import Pagination from '@/components/Pagination'
export default {
  name: 'diseaseInfo',
  data () {
    return {
      gdb3: false,
      gdb2: false,
      id: this.$route.params.id, // 疾病id
      type: this.$route.params.type, // 疾病类别(只有两个值，分别为“disease”和“tumour”)
      sample_type: this.util.getLS(this.api.sample_type), // 样本检测类型
      activeTab: '',
      activeTab2: '',
      name: '', // 疾病名称
      conclusion: 1, // 风险级别
      desc: '', // 疾病概述
      heritability: '', // 疾病遗传度
      current_result: '', // 现状测试结果
      heritable_loc: [], // 易感性---风险评估
      conclusion_assess: { // 遗传性---风险评估
        risk_level: 9.314, // 患病风险倍数
        min_risk_level: 0.62, // 患病风险倍数最小值
        max_risk_level: 11.945, // 患病风险倍数最大值
        risk_of_illness: 0.279427, // 终生患病风险概率
        risk_of_illness_chinese: 0.03, // 中国人终生患病风险概率
        low_percentage: 98, // 患病风险比用户低的人群占比
        equal_percentage: 0.01, // 患病风险与用户相同的人群占比
        high_percentage: 1.99 // 患病风险比用户高的人群占比
      },
      tumour_info: [], // 用于判断当前易感性疾病是否携带遗传性
      gene: [], // 易感性---基因列表
      gene_list: [], // 遗传性---基因列表
      documentsTumour: [], // 易感性---参考文献
      documentsDisease: [], // 遗传性---参考文献
      fake_gene: '', // 假基因
      single: '', // XY同源染色体判断结果
      factors: '', // 致病因素
      symptom: '', // 早期症状
      screening: '', // 体检筛查
      advices: '', // 生活建议
      screening1: [],
      dsystem: '', // 系统
      nontumorous:false,//非肿瘤
    }
  },
  components: {
    Search,
    ExpandableText,
    DiseaseRisk,
    GeneList,
    Paper,
    Pagination
  },
  methods: {
    getDiseaseDetails () { 
      this.util.get(this.api.diseases_details + '?id=' + this.id + '&type=' + this.type, '', (success) => {
        if (this.type === 'tumour') {
          this.heritable_loc=[success.details.heritable_loc]
          this.gene = success.details.gene
          this.documentsTumour = success.details.documents
        } else {
          this.conclusion_assess = success.details.risk_info
          this.gene_list = success.details.gene_list
          this.documentsDisease = success.details.documents

          if (success.details.tumour_info.length !== 0) {
            this.tumour_info = success.details.tumour_info
            this.documentsTumour = success.details.tumour_info.documents
            this.gene = success.details.tumour_info.gene
          }else{
               this.tumour_info = []
          }
        }
        if (success.details.fake_gene) {
          this.fake_gene = success.details.fake_gene
        }
        if (success.details.single) {
          this.single = success.details.single
        }
        this.name = success.details.name
        this.conclusion = success.details.conclusion
        this.desc = success.details.desc
        this.factors = success.details.factors
        this.symptom = success.details.symptom
        this.screening = success.details.screening
        this.advices = success.details.advices
        this.heritability = success.details.heritability
        this.current_result = success.details.current_result
        this.dsystem = success.details.dsystem
      })
    },
    // gdb2
    // 疾病信息
    getDiseaseDetails1 () {
      this.util.get1(this.api.diseaseDetails + '?itemid=' + this.id, '', (success) => {
        this.conclusion_assess = success.conclusion_assess
        this.gene_list = success.gene.gene_list
        this.documentsDisease = success.paper
        this.name = success.chname
        this.conclusion = success.conclusion
        this.desc = success.dis_desc
        this.factors = success.dis_factor
        this.symptom = success.dis_symptom
        this.screening = success.dis_screening
        this.advices = success.dis_advice
        this.heritability = success.heritability
        // this.current_result = success.current_result
      })
    },
    // 肿瘤信息
    getTumourDetails () {
      this.util.get1(this.api.tumourDetails + '?itemid=' + this.id, '', (success) => {
        this.heritable_loc = success.inherit.screening
        this.gene = success.inherit.gene.split(',')
        this.name = success.chname
        this.conclusion = success.conclusion
        if (success.hasOwnProperty('susceptible')) {
          this.conclusion_assess = success.susceptible.conclusion_assess
          this.gene_list = success.susceptible.gene.gene_list
        } else {
          this.conclusion_assess = null
          this.gene_list = []
        }
        this.desc = success.dis_desc
        this.factors = success.dis_factor
        this.symptom = success.dis_symptom
        this.screening = success.dis_screening
        this.screening1 = success.inherit.screening
        this.advices = success.dis_advice
        this.heritability = success.heritability
        this.documentsDisease = success.paper
        // this.current_result = success.current_result
      })
    }
  },
  created(){

console.log(this,'肿瘤遗传性评估')
  },
  mounted () {
    console.log(this.util.getLS(this.api.status) === 1)
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getDiseaseDetails()
    } else {
      this.gdb2 = true
      if (this.type === 'disease') {
        this.getDiseaseDetails1()
      } else {
        this.getTumourDetails()
      }
    }
  },
  watch: {
    '$route' (to) {
      this.id = parseInt(to.params.id)
      this.type = to.params.type
      this.getDiseaseDetails()
    },
    dsystem(newVul,oldVal){
      console.log(newVul,oldVal)
      if(newVul==='肿瘤'){
        this.nontumorous=false
      }else{
        this.nontumorous=true
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/functions";
  .disease_info {

    .risk {
      background-color: #fff;
      margin: pxToRem(30px) 0;
      padding: pxToRem(36px);

      p{
        margin-bottom: pxToRem(20px);
      }

      .risk_title {
        font-weight: 600;
        font-size: pxToRem(30px);
      }

      .risk_factors {
        margin: pxToRem(40px) 0;
      }

      .risk_percent {
        font-size: pxToRem(50px);
        padding: 0 pxToRem(20px);
      }

      .risk_resultTitle {
        margin-top: pxToRem(30px);
      }

      .risk_result {
        text-align: center;
        padding-left:  pxToRem(60px);
        font-size: pxToRem(40px);
        margin-bottom: pxToRem(50px);
      }

      .risk_implication {
        display: block;
        text-align: right;
        color: #007aff;
      }
    }

    .box .box_title {
      font-size: pxToRem(30px);
      padding: pxToRem(36px);
      font-weight: 600;
      border-bottom: pxToRem(1px) solid #f8f8f8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/disease/diseaseInfo.vue